// @ts-check
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Route, Switch } from "react-router-dom";

import { IframeOrFullPageWrapper } from "components/Container";
import TxnDetailsContainer from "components/TxnDetails/TxnDetailsContainer";
import ScrollToTop from "components/ScrollToTop";
import { FLOW_STATE } from "utils";
import { useFlowConfig } from "flows/hooks";

import TxnHistoryRoute from "./components/TxnHistoryRoute";
import Header from "flows/components/Header";

/**
 * TxnHistory
 * @description
 * Transaction history flow
 * @param {object} props
 * @param {OnReady} props.onReady
 * @param {OnUpdate} props.onUpdate
 * @param {OnComplete} props.onComplete
 * @param {OnError} props.onError
 */
export default function TxnHistory({ onReady, onUpdate, onComplete, onError }) {
  const { formatMessage } = useIntl();
  useEffect(onReady, [onReady]);
  const { hideExitButtons } = useFlowConfig();

  const [selectedAccountId, setSelectedAccountId] = useState(null);

  const handleCloseButtonClicked = () => {
    onComplete({
      state: FLOW_STATE.COMPLETE,
      trigger: "header-close-button",
    });
  };

  return (
    <IframeOrFullPageWrapper includeTosAndPrivacy withoutPadding>
      <ScrollToTop>
        <Switch>
          <Route exact path={`/txnhistory/`}>
            <TxnHistoryRoute
              onClose={handleCloseButtonClicked}
              selectedAccountId={selectedAccountId}
              onSelectAccountId={setSelectedAccountId}
            />
          </Route>

          <Route
            path={`/txnhistory/:transactionId`}
            render={({ match, history }) => (
              <>
                <Header
                  showLanguage
                  title={formatMessage({
                    defaultMessage: "Transaction details",
                    description: "Header title",
                  })}
                  onBackButtonClick={history.goBack}
                  onCloseButtonClick={!hideExitButtons ? handleCloseButtonClicked : undefined}
                />
                <TxnDetailsContainer
                  transactionId={match.params.transactionId || null}
                  accountId={selectedAccountId}
                  onUpdate={onUpdate}
                  onComplete={onComplete}
                  onError={onError}
                  hideExitButton={
                    true /* Since Txn History header contains a close, we don't need to show one within the component */
                  }
                />
              </>
            )}
          />
        </Switch>
      </ScrollToTop>
    </IframeOrFullPageWrapper>
  );
}
